import { render, staticRenderFns } from "./disposalPasport.vue?vue&type=template&id=6209643c&scoped=true"
import script from "./disposalPasport.vue?vue&type=script&lang=js"
export * from "./disposalPasport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209643c",
  null
  
)

export default component.exports